@if (!isLoading()) {
  <div
    class="claims-report-container"
    data-e2e="claims-report-container"
  >
    <dxo-tabs
      #tabsRef
      [default]="selectedTab()"
    >
      @if (hasLifeClaims()) {
        <dxo-tab
          [header]="LifeTabLabel"
          [templateRef]="lifeTab"
        ></dxo-tab>
      }
      @if (hasDisabilityClaims()) {
        <dxo-tab
          [header]="DisabilityTabLabel"
          [templateRef]="disabilityTab"
        ></dxo-tab>
      }
      <!-- Life Tab Content -->
      <ng-template #lifeTab>
        <div>
          @if (!hasLifeClaims()) {
            <dxo-alert
              status="info"
              [text]="AlertText"
              [dismissable]="false"
            ></dxo-alert>
          }
        </div>
        @if (hasLifeClaims()) {
          <div class="card-container">
            @for (report of lifeReports; track trackByReportId(report)) {
              <app-list-card
                [title]="report.title"
                [bodyText]="report.bodyText"
                [buttons]="report.buttons"
                [statuses]="report.statuses"
                [attr.data-e2e]="report.title"
              ></app-list-card>
            }
          </div>
        }
      </ng-template>
      <!-- Disability Tab Content -->
      <ng-template #disabilityTab>
        <div>
          @if (!hasDisabilityClaims()) {
            <dxo-alert
              status="info"
              [text]="AlertText"
              [dismissable]="false"
            ></dxo-alert>
          }
        </div>
        @if (hasDisabilityClaims()) {
          <div class="card-container">
            @for (report of disabilityReports(); track trackByReportId(report)) {
              <app-list-card
                [title]="report.title"
                [bodyText]="report.bodyText"
                [buttons]="report.buttons"
                [statuses]="report.statuses"
                [attr.data-e2e]="report.title"
              ></app-list-card>
            }
          </div>
        }
      </ng-template>
    </dxo-tabs>
  </div>
}

@if (isLoading()) {
  <div class="loader-container">
    <dxo-circular-loader
      [size]="'medium'"
      [color]="'blue'"
    ></dxo-circular-loader>
  </div>
}
